module.exports = __webpack_public_path__ + "img/support_service.7f0bb600.png";